// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"f0bdedb1","52":"c4a0ec85","498":"2e9e737b","513":"ef4673b3","703":"2c2256a5","787":"3d3b2fb0","851":"7129d9c1","897":"66ffaf8e"}[chunkId] + ".chunk.js";
};